import React from 'react'
import { useTranslation } from 'react-i18next'

import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'

import { calculatePackagingQuantity } from '../../../../../utils/deliveryforecast-despatchadvice/calculatePackagedQuantity'
import { useAllDeliveryForecastDespatchAdviceItems } from '../../../data'
import { useDeliveryForecastDespatchAdviceItemPackagingById } from '../../../data/hooks'

type Props = {
  despatchAdviceId: string
  itemId: string
  packagingId: string
}

export const SummaryShippingTable: React.FC<Props> = ({
  despatchAdviceId,
  itemId,
  packagingId,
}) => {
  const { t, i18n } = useTranslation()
  const { language } = i18n
  const { data: items } =
    useAllDeliveryForecastDespatchAdviceItems(despatchAdviceId)
  const { data: packagings } =
    useDeliveryForecastDespatchAdviceItemPackagingById(
      despatchAdviceId,
      itemId,
      packagingId,
    )

  const confirmationQuantity = items?.[0].ConfirmationQuantity || 0
  const packagedQuantity = calculatePackagingQuantity(packagings)

  const summaryData = [
    {
      fieldName: t(
        'deliveryForecastDespatchAdvice.shippingDetails.summaryShippingTable.columns.deliveryQuantity.header',
      ),
      quantity: confirmationQuantity.toLocaleString(language),
    },
    {
      fieldName: t(
        'deliveryForecastDespatchAdvice.shippingDetails.summaryShippingTable.columns.packagedQuantity.header',
      ),
      quantity: packagedQuantity?.toLocaleString(language),
    },
  ]

  const header = (
    <h3 className="my-1">
      {t(
        'deliveryForecastDespatchAdvice.shippingDetails.summaryShippingTable.title',
      )}
    </h3>
  )

  return (
    <DataTable
      header={header}
      showHeaders={false}
      value={summaryData}
      className="mt-6 max-w-24rem"
    >
      <Column field="fieldName"></Column>
      <Column field="quantity" align="right"></Column>
    </DataTable>
  )
}
